{
  "en": {
    "worksheet": {
      "autoSave": {
        "saved": "Changes saved",
        "saveFailed": "Changes could not be saved",
        "sessionExpired": "Your session has expired. Please log in again to save changes.",
        "draftRestoreFailed": "Draft could not be restored"
      },
      "submitFailed": "Submission failed. Please try again.",
      "aiGenerator": {
        "breadcrumbs": {
          "course": "Course",
          "knowledge": "Knowledge",
          "topic": "Topic"
        },
        "buttons": {
          "createWorksheet": "Create worksheet",
          "creating": "Processing …"
        },
        "course": {
          "grade": "Grade level",
          "language": "Language",
          "school": "School type",
          "subject": "Subject"
        },
        "errors": {
          "generationFailed": "The worksheet could not be created. Please try again."
        },
        "headers": {
          "createTitle": "Create worksheet with AI assistance"
        },
        "knowledge": {
          "subtitle": "Optionally, you can add a source from which the AI extracts the background knowledge for the worksheet."
        },
        "labels": {
          "languageLevel": "Select language level (CEFR)",
          "learningObjectiveHeading": "Learning objective for this worksheet",
          "topicHeading": "Topic or question for this worksheet"
        },
        "placeholders": {
          "learningObjectiveHeading": "Which competencies should be developed? (e.g., analysis and evaluation of the starting conditions of the Weimar Republic).",
          "topicHeading": "What main topics should the worksheet cover? (e.g., \"The Beginning of the Weimar Republic\")"
        },
        "tooltips": {
          "generateLearningObjectives": "Suggest learning objectives with AI",
          "generateLearningObjectivesDisabled": "First enter a topic to get learning objectives suggested"
        }
      },
      "aiPromptModal2": {
        "headers": {
          "title": "Generate text exercise with AI"
        },
        "labels": {
          "prompt": "Requirements"
        },
        "placeholders": {
          "prompt": "Describe the focus of the task and, if necessary, provide a key question or learning goal."
        },
        "description": "What do you want to create?"
      },
      "aiGeneration": {
        "createWithAi": "Create with AI",
        "dropdownLabel": "AI generation options",
        "pending": "AI is creating content...",
        "menu": {
          "newVariant": "Vary content",
          "harder": "Harder task",
          "easier": "Easier task",
          "addHelp": "Add guidance",
          "simpleLanguage": "Simple language",
          "custom": "Custom request"
        },
        "prompts": {
          "newBlock": "Create a suitable {blockType} block as the next meaningful step in this worksheet.",
          "newVariant": "Create a variant of this block: Change the context, numbers, or wording so that the task cannot be solved from memory of the original. Keep the learning objective and difficulty the same.",
          "harder": "Make this block more challenging by requiring more thinking—not more work.",
          "easier": "Make this block easier: Simplify the language and structure and remove unnecessary information. Keep the learning objective and technical terms—explain technical terms instead of replacing them.",
          "addHelp": "Add guidance, intermediate steps, or examples without giving away the solution.",
          "simpleLanguage": "Rewrite this block in simple language. Keep technical terms from the learning objective and block, and explain them where needed.",
          "guidance": {
            "fillInTheBlank": "For fill-in-the-blank: fill the description and cloze text; vary the gaps to match the request."
          }
        }
      },
      "aiContext": {
        "title": "AI Focus for this Worksheet",
        "button": "AI Settings",
        "description": "Here you can specify for whom you are creating the worksheet. This information helps the AI suggest suitable tasks for you. In each task block, you can have the AI suggest content.",
        "sections": {
          "schoolDetails": {
            "title": "School Key Data"
          },
          "backgroundKnowledge": {
            "title": "Background Knowledge"
          }
        },
        "labels": {
          "subjectTypes": "Subject",
          "schoolTypes": "School Type",
          "gradeLevels": "Grade Level",
          "locale": "Language",
          "addBackgroundKnowledge": "Add Background Knowledge",
          "backgroundKnowledge": "Background Knowledge for the AI"
        },
        "descriptions": {
          "addBackgroundKnowledge": "Add background knowledge from various sources, such as file uploads, websites, YouTube videos, audio files, or videos."
        },
        "actions": {
          "removeSource": "Remove Source"
        },
        "hints": {
          "hasSources": "Sources available"
        },
        "sourceKinds": {
          "text": "Text",
          "file": "File",
          "pdf": "PDF",
          "image": "Image",
          "website": "Website",
          "youtube": "YouTube",
          "audio": "Audio",
          "video": "Video"
        },
        "flash": {
          "saveFailed": "AI settings could not be saved"
        },
        "sourcePicker": {
          "title": "Add background knowledge",
          "subtitle": "Select a source and the AI will extract the text as background knowledge for the worksheet."
        },
        "recent": {
          "empty": "No sources yet. Add background knowledge first.",
          "error": "The most recently used sources could not be loaded."
        },
        "placeholders": {
          "backgroundKnowledge": "Add information and highlight content aspects that are particularly important to you..."
        }
      },
      "blockTypes": {
        "Divider": "Divider",
        "File": "File",
        "FillInTheBlankText": "Fill in the Blank",
        "H5p": "H5P",
        "Hint": "Hint",
        "Image": "Image",
        "MultipleChoice": "Multiple Choice",
        "SingleChoice": "Single Choice",
        "Spacer": "Space",
        "PageBreak": "Page Break",
        "StaticText": "Rich Text",
        "Text": "Text Response",
        "Upload": "File Submission",
        "Video": "Video",
        "ToTeachExercise": "to teach Exercise"
      },
      "blockTypesV2": {
        "Upload": "File Submission",
        "ToTeachExercise": "to teach Exercise"
      },
      "inserterHints": {
        "toTeachExercise": "New: Use your to teach content in your fobizz worksheets.",
        "pageBreak": "New: Focus the view with page breaks."
      },
      "navigation": {
        "headline": "Your Progress",
        "previousPage": "Back",
        "nextPage": "Next Page"
      },
      "buttons": {
        "addOption": "Add option",
        "submit": "Submit",
        "confirmDelete": "Yes, delete",
        "duplicate": "Duplicate",
        "generate": "Generate",
        "deleteResponse": "Delete submission",
        "moveDown": "Move down",
        "moveUp": "Move up",
        "remove": "Delete",
        "removeOption": "Remove option"
      },
      "elements": "Elements",
      "addNewBlock": "Add new block",
      "multimedia": "Multimedia",
      "layout": "Layout",
      "feedback": {
        "form": {
          "actions": {
            "reset": {
              "label": "Delete feedback",
              "message": {
                "success": "Feedback deleted"
              }
            },
            "submit": {
              "label": "Save feedback",
              "message": {
                "error": "Feedback could not be saved",
                "success": "Feedback has been saved"
              }
            }
          },
          "fieldset": {
            "text": {
              "label": "Write personal note"
            }
          },
          "headline": "Add individual feedback"
        },
        "public": {
          "headline": "Feedback to your worksheet from {name}"
        },
        "shareLinkBox": "Share your feedback to this response",
        "status": {
          "hasFeedback": "Feedback added"
        }
      },
      "fillInTheBlankDefault": {
        "answerOption": "This is an example of a gapped text with a {'{'}  gap {'}'}. There can be {'{'} many/multiple/various {'}'} possible answers provided. In this case, in the first sentence, 'gap' would be the correct answer. In the second sentence, both 'many,' 'multiple,' and 'various' would be correct.",
        "description": "Your description text with instructions for editing (not the gapped text). You can also offer suggested solutions for the assignment, for example, like this: 'Fill in the gapped text with the following terms: <i><mark>Word 1</mark></i>, <i><mark>Word 2</mark></i>...'"
      },
      "fillInTheBlankEditor": {
        "descriptionLabel": "Description text",
        "descriptionHint": "Use the description text for editing instructions. You can also offer suggested solutions for the assignment. For example {italic}",
        "descriptionHintItalic": "\"Fill in the blanks with the following terms: Germany, Federal State, Republic,...\"",
        "clozeLabel": "Fill-in-the-blank text",
        "clozeHint": "\"Example of a fill-in-the-blank text with a <strong>{'{'} gap {'}'}</strong>. Multiple <strong>{'{'} many/multiple {'}'}</strong> answers can be defined.\" In this case, 'gap' would be the correct answer and in the second sentence both 'many' and 'multiple' would be correct.",
        "insertGap": "Insert gap"
      },
      "flash": {
        "addOptionSuccess": "Option added",
        "createBlockSuccess": "Block added",
        "createSolutionSuccess": "Solution added",
        "deleteBlockSuccess": "Block deleted",
        "duplicateBlockSuccess": "Block duplicated",
        "deleteOptionSuccess": "Option deleted",
        "deleteSolutionSuccess": "Solution deleted",
        "moveBlockSuccess": "Block moved",
        "updateBlockSuccess": "Block updated",
        "updateClozeTestSuccess": "Fill in the blank text updated",
        "updateOptionSuccess": "Option updated",
        "updateSolutionSuccess": "Solution updated",
        "updateWorksheetSuccess": "Worksheet updated",
        "updateWorksheetError": "Worksheet could not be updated"
      },
      "headings": {
        "saveShareLink": "Remember the link to this page in case you want to access your results later."
      },
      "hints": {
        "Divider": "Use this horizontal divider to structure the worksheet visually.",
        "File": "Upload extra work material here (e.g. a text file, an image or a PDF) that you want your students to download or view. Tip: Use the Upload task block to make your students submit their own version of the material within the same worksheet.",
        "FillInTheBlankText": "Write a text or individual questions with predefined answers to be filled in. Use the symbols {'{'} and {'}'} to mark a gap in the text and enclose the correct word or words. For multiple correct answer options, use the symbol / as a divider. For example, you could write: \"The student has to fill in {'{'}a/the{'}'} gap.\" In this case, both answers 'a' and 'the' are correct. All answers are automatically evaluated.",
        "H5p": "Embed interactive H5P content into your worksheet. Upload an .h5p file to create interactive exercises, quizzes, and learning games.",
        "Hint": "Give your students extra information with this visual hint.",
        "Image": "Add an image from the image search or upload your own image to enrich your worksheet with visual content.",
        "MultipleChoice": "Ask a question and provide possible answers. Mark the correct answers by selecting the circles next to them. The evaluation indicates which tasks were easy and where your students still need the most repetition.",
        "SingleChoice": "Ask a question and provide possible answers. Mark the correct answer by selecting the circle next to it. The evaluation indicates which tasks were easy and where your students still need the most repetition.",
        "Spacer": "Add some white space to structure the worksheet visually.",
        "PageBreak": "Use page breaks to split the worksheet into multiple pages you can navigate between.",
        "StaticText": "Use the text element to provide explanations and additional information for your students. Note that they cannot hand in anything here. Use the text response for this.",
        "Text": "Write a work assignment for which your students can digitally submit a response in a text field.",
        "Upload": "Create an assignment for your students to upload a file (e.g., a text file, an image, or a PDF). All submitted files can later easily be reviewed and evaluated in one place.",
        "ToTeachExercise": "Search for interactive exercises from to teach and embed them directly into your worksheet.",
        "Video": "Embed YouTube or Vimeo videos by entering the URL here (for example: https://vimeo.com/469669139).",
        "answered": "answered",
        "dragNDrop": "Hint: Upload your file directly via drag & drop",
        "dropFileHere": "Drop file here or select file",
        "dropH5pFileHere": "Drop H5P file here or",
        "uploadH5pFilePrompt": "Drop H5P file here or select file",
        "elements": "Include explanations and content for your students and structure your worksheet.",
        "h5pContentStatus": "Status: {status}",
        "h5pFileRequirement": "Only .h5p files are allowed",
        "h5pProcessing": "H5P content is being processed, please wait...",
        "h5pProcessingFailed": "H5P processing failed. Please try again.",
        "h5pProcessingStalled": "Processing this H5P content is taking unusually long. Please try again later or contact support.",
        "h5pReloadHint": "Content not displaying? Reload page",
        "h5pFileUploadSuccess": "H5P file uploaded successfully.",
        "h5pPreviewHint": "You can try the module in the preview.",
        "toTeachExerciseImportSuccess": "to teach exercise imported successfully.",
        "maxOptionsReached": "Maximum of {max} options can be added.",
        "name": "Insert your pseudonym or name abbreviation here.",
        "noDescriptionOrCloze": "No description or fill in the blank text entered",
        "emptyBlock": "<strong>This block is empty.</strong> It will not appear in the preview or in the student view.",
        "noDescriptionOrOptions": "No description or options entered",
        "fileUploadSuccess": "File uploaded successfully.",
        "noFile": "No file uploaded",
        "noH5pContent": "No H5P content uploaded",
        "h5pNotPrintable": "This interactive content cannot be printed.",
        "noHint": "No hint entered",
        "noImage": "No image uploaded",
        "noInput": "No input",
        "selectFile": "Select file",
        "noSolution": "No solution entered",
        "noText": "No text entered",
        "noVideo": "No video embedded",
        "processingH5pFile": "Processing H5P file...",
        "questions": "Create assignments with fields that your students can fill in.",
        "submitSuccessful": "Thank you! You have successfully submitted your worksheet.",
        "searchToTeachExercises": "Search to teach exercises...",
        "processingToTeachExercise": "Importing and processing to teach exercise...",
        "noToTeachExercisesFound": "No exercises found",
        "noToTeachExercise": "No to teach exercise selected",
        "toTeachSsoNotLinked": "Your account is not yet linked with to teach. Connect your account to use your to teach content on fobizz. <a href=\"https://to-teach.ai/auth/fobizz\" target=\"_blank\" rel=\"noopener noreferrer\">Go to to teach</a>",
        "videoError": "The given URL is invalid. Please insert a valid address or remove it.",
        "videoExample": "Example: https://vimeo.com/469669139"
      },
      "labels": {
        "clozeGap": "Gap {current} of {total}",
        "confirmDeleteBlock": "Delete block?",
        "confirmDeleteBlockText": "Warning: If you remove this block, all associated submissions will also be deleted.",
        "confirmDeleteResponse": "Are you sure you want to delete this submission?",
        "confirmDeleteResponseText": "Should the response really be deleted?",
        "confirmSubmitIncompleteResponse": "You have not filled in all the questions yet. Do you still want to submit your answer?",
        "confirmSubmitResponse": "Do you want to submit the worksheet now?",
        "confirmSubmitResponseTitle": "Submit worksheet?",
        "confirmSubmitKeepEditing": "Keep editing",
        "confirmSubmitAnyway": "Yes, submit",
        "draft": "Draft | Drafts",
        "response": "Submission | Submissions",
        "responseStatus": {
          "draft": "In Progress",
          "submitted": "Completed"
        },
        "respondingAs": "You are answering this worksheet as {pseudonym}",
        "responsesTab": "Drafts and Submissions",
        "worksheet": "Worksheet"
      },
      "links": {
        "shareResponse": "Copy student link",
        "showResponseSolutionToggle": "Show sample solution",
        "taskNo": "Task #{ index }"
      },
      "placeholders": {
        "FillInTheBlankText": "Enter fill in the blank text",
        "answerInput": "Insert answer",
        "clickToEdit": "Click to edit",
        "description": "Enter description",
        "hint": "Enter hint",
        "imageCaption": "Insert image caption",
        "optionInput": "Insert option",
        "videoCaption": "Insert video caption",
        "videoUrl": "Insert video url"
      },
      "questions": "Questions",
      "solution": {
        "actions": {
          "add": "Add sample solution",
          "delete": "Delete sample solution",
          "showResponseSolution": "Show all solutions after submission"
        },
        "hints": {
          "showResponseSolution": "Your students will see the sample solutions after submitting their answers."
        },
        "title": "Sample solution",
        "types": {
          "text": {
            "placeholder": "Enter sample solution..."
          }
        }
      },
      "words": {
        "of": "of"
      }
    }
  }
}
